exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, "\n.spacebtn[data-v-92c5e638] {\n  margin-bottom: 10px;\n}\n.box-card[data-v-92c5e638] {\n  width: 95%;\n  margin: 20px auto;\n}\n", "", {"version":3,"sources":["/tentcoo/jenkins/workspace/epm-prod-deploy-web-pc/src/views/project-manage/projectContact.vue"],"names":[],"mappings":";AACA;EACE,oBAAoB;CACrB;AACD;EACE,WAAW;EACX,kBAAkB;CACnB","file":"projectContact.vue","sourcesContent":["\n.spacebtn[data-v-92c5e638] {\n  margin-bottom: 10px;\n}\n.box-card[data-v-92c5e638] {\n  width: 95%;\n  margin: 20px auto;\n}\n"],"sourceRoot":""}]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"sourceMap":true}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-92c5e638","scoped":true,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/views/project-manage/projectContact.vue
// module id = XLXN
// module chunks = 6